(()=>{
 const init=()=>{
  document.querySelectorAll('details[data-maison-menu]').forEach(detail=>{
   if(detail.dataset.maisonReady)return;
   detail.dataset.maisonReady='true';
   const summary=detail.querySelector(':scope > summary');
   let timer;
   let pointerWasOpen;
   const close=()=>{clearTimeout(timer);detail.open=false;summary.setAttribute('aria-expanded','false');};
   const open=()=>{clearTimeout(timer);document.querySelectorAll('details[data-maison-menu][open]').forEach(other=>{if(other!==detail){other.open=false;other.querySelector(':scope > summary').setAttribute('aria-expanded','false');}});detail.open=true;summary.setAttribute('aria-expanded','true');};
   detail.addEventListener('pointerenter',e=>{if(e.pointerType==='mouse')open();});
   detail.addEventListener('pointerleave',e=>{if(e.pointerType==='mouse'&&!detail.matches(':focus-within'))timer=setTimeout(close,160);});
   detail.addEventListener('focusin',open);
   detail.addEventListener('focusout',()=>{setTimeout(()=>{if(!detail.matches(':focus-within')&&!detail.matches(':hover'))close();},0);});
   summary.addEventListener('pointerdown',()=>{pointerWasOpen=detail.open;});
   summary.addEventListener('click',e=>{e.preventDefault();const wasOpen=pointerWasOpen===undefined?detail.open:pointerWasOpen;pointerWasOpen=undefined;wasOpen?close():open();});
   detail.addEventListener('keydown',e=>{if(e.key==='Escape'){e.preventDefault();e.stopPropagation();summary.focus();close();}});
   detail.addEventListener('toggle',()=>{summary.setAttribute('aria-expanded',String(detail.open));});
  });
 };
 document.addEventListener('click',e=>{if(!e.target.closest('details[data-maison-menu]'))document.querySelectorAll('details[data-maison-menu][open]').forEach(d=>{d.open=false;d.querySelector(':scope > summary').setAttribute('aria-expanded','false');});});
 document.addEventListener('shopify:section:load',init);
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
})();
